export const LOADING_PAGE_HOME = 'LOADING_PAGE_HOME';
